<template>
	<div class="ml-45 mr-44">
		<div class="flex j-between  pb-26 a-center postpicksTop" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
			<div class="flex le">
				<div class="userreplies-right-btn tit-16 cur_pointer z-878787 B-300 mr-15" @click="Shai(0)" :class="likeindex==0?'repliesxuan':''">{{gudingziduan.Personal.Posts}}</div>
				<div class="userreplies-right-btn tit-16 cur_pointer z-878787 B-300 "  @click="Shai(1)" :class="likeindex==1?'repliesxuan':''">{{gudingziduan.Personal.MyPicks}}</div>
			</div>
			<!-- <div class="flex" v-if="likeindex==1">
				<div class="tit-14  cur_pointer"  @click="Shais(0)" :class="likeindex2==0?'z-E60012':'ys-black'">Likes({{Likesnum}})</div>
				<div class="tit-14  cur_pointer pr-43 pl-52"  @click="Shais(1)" :class="likeindex2==1?'z-E60012':'ys-black'">Favorite({{Favoritenum}})</div>
				<div class="tit-14  cur_pointer"  @click="Shais(2)" :class="likeindex2==2?'z-E60012':'ys-black'">Reply({{Replynum}})</div>
			</div> -->
			<el-date-picker v-if="likeindex==0" class="cur_pointer repliesinputs" :append-to-body="false" v-model="postdate"
				type="month" prefix-icon="el-icon-time" :placeholder="gudingziduan.Personal.date"></el-date-picker>
		</div>
		<!-- <el-divider></el-divider> -->
	<!-- 	<div class="userreplies-right-contrn pt-7" v-if="likeindex2==2 && likeindex==1">
			<div class="flex pl-21  pt-37 pb-37 br-10 userreplies-right-replieslie" v-for="(r,i) in replies" >
				<div class="tit-15 B-300" style="color: #838383;width:49px;height:49px;">
					<img :src="require('@/assets/pc/group/AI.png')" style="width:100%;height:100%" />
				</div>
				<div class="ml-33" style="width: 92%;">
					<div class="flex j-between">
						<div class="tit-16 ys-66">
							<span>{{r.name}}</span>
							<span class="pl-10 pr-10">Reply to</span>
							<span>{{r.reply}}</span>
						</div>
						<div class="tit-14 ys-77 pt-2">{{r.time}}</div>
					</div>
					<div class="tit-15 ys-66 pt-15 B-300" style="line-height: 19px;">{{r.contant}}</div>
				</div>
			</div>
			<el-pagination class="flex j-center pb-108 pt-60"  @current-change="handleCurrentChange"
				:current-page.sync="so.page" :page-size="so.jitiao" layout="prev, pager, next, jumper,slot" :total="zongshu">
				<span class="ml-10 cur_pointer" @click="goToPage">go</span>
			</el-pagination>
		</div> -->
		<div class="userreplies-right-contrn pt-35" v-if="likeindex==1">
			<div class="pl-21 mb-19 pt-22 pb-30 br-10 pr-24  userreplies-right-likeslie cur_pointer" v-for="(l,i) in likes"  @click="$router.push({name: 'details',params:{id:l.id}})">
				<div class="flex j-between w100">
					<div class="flex a-center flex-wrap pickTop">
						<!-- <div class="tit-15 B-300" style="color: #838383;width:25px;height:25px; flex-shrink: 0; display: flex; align-items: center;">
							<img :src="require('@/assets/pc/group/AI.png')" style="width:100%;height:100%" />
						</div> -->
						<div class="tit-16 flex a-center j-center"
							style="width: .25rem; height: .25rem; min-width:.25rem;min-height:.25rem;text-align: center;color: white;border-radius: 50%; flex-shrink: 0;"
							:style="wuserid == l.userId && colorzu1? { background: `linear-gradient(135deg, ${colorzu[0]}, ${colorzu[1]})` }:getRandomGradients(l,i)">{{getFirstLetter(l.nickName)}}</div>
						
						<div class="tit-16 ys-33 pl-8 pr-14">{{l.nickName}} LIKE</div>
				
						<div class="tit-20 ys-33 B-300 title" ><i v-if="l.title">{{l.title}}</i><i v-else>{{l.theme}}</i></div>
					</div>
					<div class="flex pickBom">
						<div class="pr-20" style="color: #626262;"><span class="iconfont icon-liuyan1 tit-16"></span><span class="tit-14 pl-4">{{l.commentNum}}</span></div>
						<div style="color: #626262;tit-14"><span class="iconfont icon-dianzan1 tit-16"></span><span  class="tit-14 pl-4">{{l.thumbsUpNum}}</span></div>
					</div>
				</div>
				<div class="tit-15 ys-9 pt-19 shengluhao2 mb-21" style="line-height:19px" v-html="l.content"></div>
				<div class="flex j-between">
					<div class="tit-14 ys-9">
						<span class="pr-4">{{l.createTime}}</span>
						<span>| {{gudingziduan.shouye.contant.postedin}} </span> 
						<!-- Posted in -->
						<span style="color:#FF071C">{{l.groupName}}</span>
					</div>
					<div class="tit-14 ys-9"><span class="pr-6">{{gudingziduan.xinzengde.LastReply}}</span> <span>{{l.latestReplyTime}}</span>  </div>
				</div>
			</div>
			<el-pagination class="flex j-center pb-108 pt-60"  @current-change="handleCurrentChange"
				:current-page.sync="so.page" :page-size="so.jitiao" layout="prev, pager, next, jumper,slot" :total="zongshu">
				<span class="ml-10 cur_pointer" @click="goToPage">go</span>
			</el-pagination>
		</div>
		<div class="userreplies-right-contrn pt-35" v-if="likeindex==0">
			<div class="pl-21 mb-19 pt-22 pb-30 br-10 pr-24  userreplies-right-likeslie cur_pointer" @click="$router.push({name: 'details',params:{id:l.id}})" v-for="(l,i) in fabutie" >
				<!-- <div>{{l.id}}</div> -->
				<div class="flex j-between w100 postTop">
					<div class="flex">
						<div class="tit-16 flex a-center j-center mt-4"
							style="width: .25rem; height: .25rem; min-width:.25rem;min-height:.25rem;text-align: center;color: white;border-radius: 50%; flex-shrink: 0;"
							:style="wuserid == l.userId && colorzu1? { background: `linear-gradient(135deg, ${colorzu[0]}, ${colorzu[1]})` }:getRandomGradients(l,i)">{{getFirstLetter(l.nickName)}}</div>
						<div class="tit-16 ys-33 pl-8 pr-14 mt-4">{{l.nickName}}</div>
						<div class="flex a-center">
							<div class="tit-20 ys-33 B-300 line1">{{l.title}}</div>
						</div>
					</div>
					<div class="flex">
						<div class="pr-20" style="color: #626262;"><span class="iconfont icon-liuyan1 tit-16"></span><span class="tit-14 pl-4">{{l.replyNum?l.replyNum:0}}</span></div>
						<div style="color: #626262;" class="tit-14"><span class="iconfont icon-dianzan1 tit-16"></span><span  class="tit-14 pl-4">{{l.thumbsUpNum?l.thumbsUpNum:0}}</span></div>
					</div>
				</div>
				<div class="tit-15 ys-9 pt-19 shengluhao2 mb-21" style="line-height: 19px;" v-html="l.content"></div>
				<div class="flex j-between pliesBom">
					<div class="tit-14 ys-9">
						<span class="pr-4">{{l.createTime}}</span>
					</div>
					<div class="tit-14 ys-9"><span class="pr-6">{{gudingziduan.xinzengde.LastReply}}</span> <span>{{l.latestReplyTime}}</span>  </div>
				</div>
			</div>
			<el-pagination class="flex j-center pb-108 pt-60" @current-change="handleCurrentChange2"
				:current-page.sync="so2.page" :page-size="so2.jitiao" layout="prev, pager, next, jumper,slot" :total="zongshu2">
				<span class="ml-10 cur_pointer" @click="goToPage2">go</span>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {myInvitation,myPicks} from '@/api/Personal.js';
	export default {
	  data() {  
	    return { 
			// likeindex:1,
			likeindex2:0,
			likeleixin:0,
			Likesnum:30,
			Favoritenum:10,
			Replynum:10,
			replies:[
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."},
			// 	{name:'Jeffrey',reply:'Gogle',time:'10/10 13:46',contant:"I'm very sorry, but this model is used as a grid-tied inverter and does not have an interface to access the battery. If you want to use the battery, you need to replace it with a storage inverter or add an AC coupled model in order to charge the battery."}
			
			],
			likes:[
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"},
				// {name:'Alek',like:0,lastime:'2024-10-08',reply:6,title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Key attributes Industry-specific attributes Output Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang Type DUAL Type DC/AC Inverters Inverter Efficiency 97.9%(Max.efficiency) Other attributes Place of Origin Guang"}
			
			],
			fabutie:[],
			so:{page:1,jitiao:10},
			so2:{page:1,jitiao:10},
			zongshu:0,
			zongshu2:0,
			postdate:'',
			wuserid:'',
			gradients:[
				['#FDEB71', '#F8D800'],
				['#ABDCFF', '#0396FF'],
				['#FEB692', '#EA5455'],
				['#CE9FFC', '#7367F0'],
				['#90F7EC', '#32CBCB'],
				['#FFF6B7', '#F6416C'],
				['#81FBB8', '#28C76F'],
				['#E2B0FF', '#9F44D3'],
				['#F97794', '#623AA2'],
				['#FCCF31', '#F55555'],
				['#F761A1', '#8C1BAB'],
				['#43CBFF', '#9708CC'],
				['#5EFCE8', '#736EFE'],
				['#FAD7A1', '#E96D71'],
				['#FFD26F', '#3677FF'],
				['#A0FE65', '#FA016D'],
				['#FFDB01', '#0E197D'],
				['#FEC163', '#DE4313'],
				['#92FFC0', '#002661'],
				['#EEAD92', '#6018DC'],
				['#F6CEEC', '#D939CD'],
				['#52E5E7', '#130CB7'],
				['#F1CA74', '#A64DB6'],
				['#E8D07A','#5312D6'],
				['#EECE13','#B210FF'],
				['#79F1A4','#0E5CAD'],
				['#FDD819','#E80505'],
				['#FFF3B0','#CA26FF'],
				['#FFF5C3','#9452A5'],
				['#F05F57','#360940'],
				['#2AFADF','#4C83FF'],
				['#FFF886','#F072B6'],
				['#97ABFF','#123597'],
				['#F5CBFF','#C346C2'],
				['#FFF720','#3CD500'],
				['#FF6FD8','#3813C2'],
				['#EE9AE5','#5961F9'],
				['#FFD3A5','#FD6585'],
				['#C2FFD8','#465EFB'],
				['#FD6585','#0D25B9'],
				['#FD6E6A','#FFC600'],
				['#65FDF0','#1D6FA3'],
				['#6B73FF','#000DFF'],
				['#FF7AF5','#513162'],
				['#F0FF00','#58CFFB'],
				['#FFE985','#FA742B'],
				['#FFA6B7','#1E2AD2'],
				['#FFAA85','#B3315F'],
				['#72EDF2','#5151E5'],
				['#FF9D6C','#BB4E75'],
				['#F6D242','#FF52E5'],
				['#69FF97','#00E4FF'],
				['#3B2667','#BC78EC'],
				['#70F570','#49C628'],
				['#3C8CE7','#00EAFF'],
				['#FAB2FF','#1904E5'],
				['#81FFEF','#F067B4'],
				['#FFA8A8','#FCFF00'],
				['#FFCF71','#2376DD'],
				['#FF96F9','#C32BAC'],
				// 这里可以添加更多的颜色组合  
			],
			 colorCache: {} ,// 新增缓存对象
			 colorzu:[],
				gudingziduan:{},
			 colorzu1:[]
		}
	},
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'video')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
	created() {
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		this.wuserid=this.$qu('guserid')
		this.colorzu1=this.$qu('uColor2_'+this.wuserid)
		// if(this.$route.query.likeindex){
			// this.likeindex = this.$route.query.likeindex
		// }
		if(this.colorzu1.length>0){
			this.colorzu=this.colorzu1.split(',');
		}
		this.Tiezifabu()
		this.Tiezipink()
	},
	props: {
		likeindex:{
			type: Number,
			default: 1
		}
	},
	methods: {
		getRandomGradients(e,k) {
		  const userId = e.userId; 
		  if (this.colorCache[userId]) {
		    // console.log('从缓存中获取颜色，userId:', userId, '颜色:', this.colorCache[userId]);
		    return `background:linear-gradient(135deg, ${this.colorCache[userId][0]}, ${this.colorCache[userId][1]})`;
		  }
		  const index = k % this.gradients.length;
		  // console.log('index', index);
		  const gradient = this.gradients[index];
		  this.colorCache[userId] = gradient;
		  // console.log('缓存新颜色，userId:', userId, '颜色:', gradient);
		  return `background:linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`;
		},
		getFirstLetter(name) {
			return name ? name.charAt(0).toUpperCase() : '?';// 返回第一个字母并转换为大写  
		},
		Shai(e){
			this.likeindex=e
			if(e==0){
				this.Tiezifabu()
			}else{
				this.Tiezipink()
			}
		},
		Shais(e){
			this.likeindex2=e
			if(e>=1){
				this.likeleixin=e
			}
		},
		//我发布的帖子 
		Tiezifabu(){
			var that=this
			myInvitation({pageNum:that.so2.page-1,pageSize:that.so.jitiao,keyWord:''}).then(shu=>{
				that.fabutie=shu.data.content
				// console.log(that.fabutie)
				that.zongshu2=Number(shu.data.totalElements)
			})
		},
		//我收藏点赞的帖子
		Tiezipink(){
			var that=this
			myPicks({pageNum:that.so.page-1,size:that.so.jitiao}).then(shu=>{
				that.likes=shu.data.content
				that.zongshu=Number(shu.data.totalElements)
			})
		},
		handleCurrentChange(e){
			this.so.page=e
			this.Tiezipink()
		},
		goToPage(){
			this.handleCurrentChange(this.so.ye)
		},
		handleCurrentChange2(e){
			// console.log(e)
			this.so2.page=e
			this.Tiezifabu()
		},
		goToPage2(){
			this.handleCurrentChange2(this.so2.ye)
		}
	}
	}; 
</script>

<style lang="scss" scoped>
	.z-878787{
		color:#878787
	}
	.z-E60012 {
		color: #E60012;
	}
	::v-deep .userreplies-right-btn{
		display: inline-block;
		padding: .1rem .30rem;
		border-radius: 100px;
		// border: 1px solid #e50012;
		box-sizing: border-box;
		background: #ececec;
	}
	::v-deep .repliesinputs{
		width:2.1rem;
		min-width: 180px;
		height:.50rem;
		min-height: 35px;
		background-color: #F6F6F8;
		border-radius: 100px;
	}
	::v-deep .repliesinputs .el-input__inner{
		background: #F6F6F8 !important;
		height: 100%;
		border-radius: 100px;
		padding-left: 40px;
		border: none;
	}
	// .repliesinput .el-input__inner {
	// 	border-radius: .25rem;
	// 	padding-left: .49rem;
	// 	background: #F6F6F8;
	// 	border: none;
	// 	width:2.1rem !important;
	// }
	::v-deep .repliesinputs .el-input__prefix {
		left: 10px;
	}

	::v-deep .repliesinputs .el-input__icon {
		font-size: var(--font20);
		color: #6b6b6b;
		display: flex;
		align-items: center;
	}
	::v-deep .repliesxuan{
		background: linear-gradient(-31deg,#e70a16 0%, #ff785c 100%);
		color: #fff;
		padding: .1rem .30rem;
	}
	::v-deep .userreplies-right-replieslie{
		// background: #F6F6F8;
		border-bottom: 1px solid #ECECEC;
		box-sizing: border-box;
	}
	::v-deep .userreplies-right-likeslie{
		background: #F6F6F8;
	}


	// 时间组件样式
	::v-deep .el-month-table td.today .cell {color: #E60012;}


// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 767px) {
	.postpicksTop {flex-wrap: wrap;}
	.postpicksTop .le {width: 100%; justify-content: center; margin-bottom: .3rem;}
	.postpicksTop .repliesinputs {margin: auto;}


	.pickTop .title {margin-top: .2rem;}
}



</style>